import { store } from '@redux/store';
import { selectPage } from 'features/articleSearchResultsFacets';
import { googleAnalytics4Event } from 'features/googleAnalytics4';
import { filter, fromEvent, map, merge, of, switchMap } from 'rxjs';

const bodyClick$ = fromEvent(document.body, 'click');
const getLinkableElement = (event) => event.target.closest('[data-page-link]');
const isAuthorArticlesSection =
    (event) => !!event.target.closest('[data-author-articles]');
const getArticleElement = (event) => event.target.closest('[data-article-card-link]');
const isArticleCard = (event) => !!event.target.closest('[data-article-card]');

const paginationContainer = document.querySelector('[data-component="blog-author-pagination"]');
const previousButton = paginationContainer.querySelector('[data-prev-button]');
const nextButton = paginationContainer.querySelector('[data-next-button]');
const optionList = paginationContainer.querySelector('[data-option-list]');

/**
 * Dispatches a Google Analytics 4 event when recommendation article is clicked.
 * @param article - is the article clicked in recommendation articles section.
 */
const triggerRecommendedArticlesClick = (article) => {
  const customProperties = {
    page_type: 'author_article_listing',
    click_target1: article.dataset.title
  };

  store.dispatch(googleAnalytics4Event({ eventName: 'related_articles_click', customProperties }));
};

const onRecommendedArticlesClick$ = bodyClick$.pipe(
  filter((event) => !!event.target.closest('[data-section-name="recommendedArticles"]')),
  map(getArticleElement),
  filter(Boolean),
);

onRecommendedArticlesClick$.subscribe(triggerRecommendedArticlesClick);

/**
* Dispatches a Google Analytics 4 event When the pagination is clicked.
* @param customProperties - is the custom properties of the event.
*/
const triggerPaginationClickEvent = function(page) {
  const customProperties = {
    page_type: 'author_article_listing',
    page_number: page,
    click_target1: 'Page Change',

  }

  store.dispatch(googleAnalytics4Event({ eventName: 'pagination_events', customProperties }));
}

// observable to emit the new page after prev button click event
const previousButton$ = fromEvent(previousButton, 'click').pipe(
  map(() => selectPage(store.getState()))
);

// observable to emit the new page after next button click event
const nextButton$ = fromEvent(nextButton, 'click').pipe(
  map(() => selectPage(store.getState()))
);

// observable to emit the new page after option button click event
const optionList$ = fromEvent(optionList, 'click').pipe(
  switchMap((event) => {
    const linkableElement = getLinkableElement(event);
    if(linkableElement) {
        event.preventDefault();
    }

    const page = Number(linkableElement?.dataset?.pageLink || 0);
    return of(page);
  })
);

merge(previousButton$, nextButton$, optionList$).subscribe(triggerPaginationClickEvent);

/**
 * Dispatches a Google Analytics event for tracking article clicks with custom properties
 */
const triggerSearchResultArticlesClick = (data) => {
    const customProperties = {
      page_type: 'author_article_listing',
      click_target1: data.dataset.title,
      Author: data.dataset.authorName,
      click_target2: 'author_article',
    };

    store.dispatch(googleAnalytics4Event({ eventName: 'article_click', customProperties }));
};

// observable to emit the article click event
const authorArticleSectionClick$ = bodyClick$.pipe(
  filter((event) => isAuthorArticlesSection(event) && isArticleCard(event)),
  map(getArticleElement),
  filter(Boolean),
);

authorArticleSectionClick$.subscribe(triggerSearchResultArticlesClick);

